const Logo = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.12108 21H15.8791C16.5614 21 17.2157 20.729 17.6981 20.2465C18.1806 19.7641 18.4516 19.1098 18.4516 18.4275V7.7475H15.8791V18.4275H5.54858C5.54858 19.1098 5.81961 19.7641 6.30205 20.2465C6.78449 20.729 7.43881 21 8.12108 21Z" fill="currentColor"/>
      <path d="M15.8791 3H8.12108C7.43881 3 6.78449 3.27103 6.30205 3.75347C5.81961 4.23591 5.54858 4.89023 5.54858 5.5725V16.2525H8.12108V5.5725H18.4516C18.4516 4.89023 18.1806 4.23591 17.6981 3.75347C17.2157 3.27103 16.5614 3 15.8791 3Z" fill="currentColor"/>
    </svg>
  );
};

export default Logo;